import { Component } from '@angular/core';
import { CONFIRMATION_MODAL } from '@shared/config/confirmation-modal.config';
import { Modal } from '@shared/modal-service/models/modal.model';
import { ConfirmationPopupModel } from '@shared/models/confirmation-popup.model';

@Component({
  selector: 'od-free-text-popup',
  templateUrl: './free-text-popup.component.html',
  styleUrls: ['./free-text-popup.component.scss'],
  standalone: false,
})
export class FreeTextPopupComponent extends Modal {
  values: ConfirmationPopupModel = {
    title: CONFIRMATION_MODAL.TITLES.delete,
    description: CONFIRMATION_MODAL.DESCRIPTIONS.delete,
    confirm: CONFIRMATION_MODAL.CONFIRMS.delete,
  };

  onInjectInputs(inputs: any): void {
    this.values = inputs;
  }
}
